import { useCallback } from 'react';
import { Modal } from '@adc/parallax-component-library';

import { buildTestId } from '~/utilities/buildTestId';
import i18n from '~/utilities/i18n';

/**
 * [Dialog types]
 * - couldn't find clinic
 * - already connected to clinc
 * - already send invite to clinic
 */
const testID = 'care-team-connection-error';

export const useCareTeamConnectionError = () => {
  const showClinicNotFoundErrorModal = useCallback(() => {
    Modal.show({
      testID: buildTestId({ testID, suffix: ['clinic', 'not', 'found'] }),
      header: '',
      details:
        "You can't share with this clinic practice because it is located in a different geographic region, or the practice ID is invalid.",
      primaryAction: {
        label: i18n.t('Global.microcopy.common.okCap'),
      },
    });
  }, []);

  const showAlreadyConnectedErrorModal = useCallback(() => {
    Modal.show({
      testID: buildTestId({
        testID,
        suffix: ['already', 'connected', 'clinic'],
      }),
      header: '',
      details: 'You are already connected to this clinic.',
      primaryAction: {
        label: i18n.t('Global.microcopy.common.okCap'),
      },
    });
  }, []);

  const showAlreadyInvitedErrorModal = useCallback(() => {
    Modal.show({
      testID: buildTestId({ testID, suffix: ['already', 'invited', 'clinic'] }),
      header: '',
      details: "You've already sent an invitation to this clinic.",
      primaryAction: {
        label: i18n.t('Global.microcopy.common.okCap'),
      },
    });
  }, []);

  return {
    showClinicNotFoundErrorModal,
    showAlreadyConnectedErrorModal,
    showAlreadyInvitedErrorModal,
  };
};
